(function () {
  function selectedVariant(section) {
    var source = section.querySelector('[data-variant-json]');
    if (!source) return null;

    var variants;
    try {
      variants = JSON.parse(source.value || source.textContent || '[]');
    } catch (error) {
      return null;
    }

    var selected = Array.prototype.map.call(
      section.querySelectorAll('[data-variant-input]:checked'),
      function (input) { return input.value; }
    );

    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selected[index];
      });
    }) || null;
  }

  function revealVariantMedia(input) {
    var section = input.closest('[data-section-type="product-template"]');
    if (!section) return;

    var variant = selectedVariant(section);
    if (!variant) return;

    var mobileVariantTitle = section.querySelector('[data-nh-mobile-variant-title]');
    if (mobileVariantTitle) mobileVariantTitle.textContent = variant.title;
    if (!variant.featured_media) return;

    window.requestAnimationFrame(function () {
      var thumb = section.querySelector('[data-product-thumb][data-id="' + variant.featured_media.id + '"]');
      if (thumb) thumb.click();
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-variant-input]');
    if (input) revealVariantMedia(input);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-nh-geolocate]');
    if (!button) return;

    var form = button.closest('form');
    var status = document.getElementById(button.getAttribute('data-status-id'));
    var latitude = form && form.querySelector('[data-nh-latitude]');
    var longitude = form && form.querySelector('[data-nh-longitude]');

    if (!navigator.geolocation || !form || !latitude || !longitude) {
      if (status) status.textContent = 'Location services are unavailable. Enter your city and ZIP code.';
      return;
    }

    button.disabled = true;
    if (status) status.textContent = 'Finding your location…';

    navigator.geolocation.getCurrentPosition(function (position) {
      latitude.value = position.coords.latitude.toFixed(6);
      longitude.value = position.coords.longitude.toFixed(6);
      button.disabled = false;
      if (status) status.textContent = 'Location added. Confirm your city and ZIP code, then submit.';
    }, function () {
      button.disabled = false;
      if (status) status.textContent = 'We could not access your location. Enter your city and ZIP code.';
    }, {
      enableHighAccuracy: false,
      timeout: 8000,
      maximumAge: 300000
    });
  });

  function normalizeRegion(value) {
    var region = String(value || '').toLowerCase().trim().replace(/[_\s]+/g, '-');
    if (region.indexOf('new-england') > -1 || region.indexOf('massachusetts') > -1 || region.indexOf('connecticut') > -1 || region === 'boston') return 'new-england';
    if (region.indexOf('new-york-city') > -1 || region === 'nyc' || region.indexOf('brooklyn') > -1 || region.indexOf('queens') > -1 || region.indexOf('manhattan') > -1 || region.indexOf('long-island-city') > -1) return 'new-york-city';
    if (region.indexOf('pennsylvania') > -1 || region.indexOf('philadelphia') > -1 || region === 'pa') return 'pennsylvania';
    if (region.indexOf('upstate') > -1 || region === 'new-york' || region === 'ny') return 'upstate-new-york';
    if (region.indexOf('northern-virginia') > -1 || region === 'virginia' || region === 'va') return 'northern-virginia';
    if (region.indexOf('st-thomas') > -1 || region.indexOf('virgin-islands') > -1 || region === 'usvi') return 'usvi';
    return 'other';
  }

  function safeAccent(value) {
    return ['blue', 'pink', 'green', 'splash'].indexOf(value) > -1 ? value : 'splash';
  }

  function directionsUrl(entry) {
    return entry.directionsUrl || 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent([entry.name, entry.address].filter(Boolean).join(', ') || 'NH2O');
  }

  function loadLocationStyles() {
    [
      ['NHLeafletStyles', 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css'],
      ['NHLeafletClusterStyles', 'https://cdn.jsdelivr.net/npm/leaflet.markercluster@1.5.3/dist/MarkerCluster.css'],
      ['NHLeafletClusterDefaultStyles', 'https://cdn.jsdelivr.net/npm/leaflet.markercluster@1.5.3/dist/MarkerCluster.Default.css']
    ].forEach(function (asset) {
      if (document.getElementById(asset[0])) return;
      var link = document.createElement('link');
      link.id = asset[0];
      link.rel = 'stylesheet';
      link.href = asset[1];
      document.head.appendChild(link);
    });
  }

  function loadLocationScript(id, src) {
    return new Promise(function (resolve, reject) {
      var existing = document.getElementById(id);
      if (existing && existing.dataset.loaded === 'true') return resolve();
      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }
      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.addEventListener('load', function () { script.dataset.loaded = 'true'; resolve(); }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  function parseLocationFeed(payload, limit) {
    var items = [];
    if (payload && payload.type === 'FeatureCollection' && Array.isArray(payload.features)) {
      items = payload.features.map(function (feature) {
        var properties = feature.properties || {};
        var coordinates = feature.geometry && feature.geometry.type === 'Point' ? feature.geometry.coordinates : [];
        return Object.assign({}, properties, { longitude: coordinates[0], latitude: coordinates[1] });
      });
    } else if (Array.isArray(payload)) {
      items = payload;
    } else if (payload && Array.isArray(payload.locations)) {
      items = payload.locations;
    }

    return items.slice(0, limit).map(function (item) {
      var latitude = parseFloat(item.latitude != null ? item.latitude : item.lat);
      var longitude = parseFloat(item.longitude != null ? item.longitude : item.lng);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || !item.name) return null;
      return {
        name: String(item.name),
        address: String(item.address || ''),
        market: String(item.market || ''),
        note: String(item.note || ''),
        locationType: String(item.location_type || item.type || ''),
        region: normalizeRegion(item.region || item.market),
        latitude: latitude,
        longitude: longitude,
        directionsUrl: String(item.directions_url || item.directionsUrl || ''),
        accent: safeAccent(String(item.accent || 'splash')),
        card: null,
        feed: true
      };
    }).filter(Boolean);
  }

  function initLocationSection(section) {
    if (!section || section.dataset.nhLocationsReady === 'true') return;
    section.dataset.nhLocationsReady = 'true';

    var mapElement = section.querySelector('[data-nh-map]');
    var directory = section.querySelector('[data-nh-directory]');
    var empty = section.querySelector('[data-nh-directory-empty]');
    var count = section.querySelector('[data-nh-visible-count]');
    var feedStatus = section.querySelector('[data-nh-feed-status]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-nh-location-card]'));
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-nh-market-tab]'));
    var mobileDetails = Array.prototype.slice.call(section.querySelectorAll('[data-nh-market-details]'));
    var mobileLists = Array.prototype.slice.call(section.querySelectorAll('[data-nh-mobile-list]'));
    var activeRegion = normalizeRegion(section.dataset.defaultMarket || 'new-england');
    var map = null;
    var layer = null;
    var entries = cards.map(function (card) {
      var latitude = parseFloat(card.dataset.latitude);
      var longitude = parseFloat(card.dataset.longitude);
      var mapButton = card.querySelector('[data-nh-show-location]');
      if (mapButton) mapButton.hidden = !Number.isFinite(latitude) || !Number.isFinite(longitude);
      return {
        name: card.dataset.name,
        address: card.dataset.address,
        market: card.dataset.market,
        note: card.dataset.note || '',
        locationType: card.dataset.locationType,
        region: normalizeRegion(card.dataset.region),
        latitude: latitude,
        longitude: longitude,
        directionsUrl: card.dataset.directionsUrl,
        accent: safeAccent(card.dataset.accent),
        card: card,
        feed: false,
        marker: null
      };
    }).filter(Boolean);

    function renderMobileCards() {
      mobileLists.forEach(function (list) {
        var region = normalizeRegion(list.dataset.nhMobileList);
        var visible = entries.filter(function (entry) { return entry.region === region; });
        list.replaceChildren();

        visible.forEach(function (entry, index) {
          var card = document.createElement('article');
          card.className = 'nh-location-card nh-location-card--mobile nh-location-card--' + entry.accent;

          var number = document.createElement('span');
          number.className = 'nh-location-card__number';
          number.textContent = String(index + 1).padStart(2, '0');

          var copy = document.createElement('div');
          var type = document.createElement('p');
          type.textContent = entry.locationType || entry.market || 'NH2O™ location';
          var name = document.createElement('h2');
          name.textContent = entry.name;
          var address = document.createElement('address');
          address.textContent = entry.address;
          copy.appendChild(type);
          copy.appendChild(name);
          copy.appendChild(address);
          if (entry.note) {
            var note = document.createElement('small');
            note.textContent = entry.note;
            copy.appendChild(note);
          }

          var actions = document.createElement('div');
          actions.className = 'nh-location-card__actions nh-location-card__actions--mobile';
          var directions = document.createElement('a');
          directions.href = directionsUrl(entry);
          directions.target = '_blank';
          directions.rel = 'noopener';
          directions.textContent = 'Get directions ↗';
          actions.appendChild(directions);

          card.appendChild(number);
          card.appendChild(copy);
          card.appendChild(actions);
          list.appendChild(card);
        });

        if (!visible.length) {
          var emptyMessage = document.createElement('p');
          emptyMessage.className = 'nh-location-directory__empty';
          emptyMessage.textContent = 'No published locations are listed for this market yet.';
          list.appendChild(emptyMessage);
        }
      });
    }

    function updateCounts() {
      section.querySelectorAll('[data-nh-market-count]').forEach(function (node) {
        var region = node.dataset.nhMarketCount;
        var marketCount = entries.filter(function (entry) { return entry.region === region; }).length;
        node.textContent = marketCount;
        var tab = node.closest('[data-nh-market-tab]');
        if (tab && region === 'other') tab.hidden = marketCount === 0;
        var details = node.closest('[data-nh-market-details]');
        if (details && region === 'other') details.hidden = marketCount === 0;
      });
      renderMobileCards();
    }

    function hasCoordinates(entry) {
      return Number.isFinite(entry.latitude) && Number.isFinite(entry.longitude);
    }

    function fitVisible(visible) {
      visible = visible.filter(hasCoordinates);
      if (!map || !visible.length) return;
      if (visible.length === 1) {
        map.setView([visible[0].latitude, visible[0].longitude], 14);
      } else {
        map.fitBounds(window.L.latLngBounds(visible.map(function (entry) { return [entry.latitude, entry.longitude]; })), { padding: [38, 38], maxZoom: 13 });
      }
    }

    function activate(region) {
      activeRegion = normalizeRegion(region);
      var visible = entries.filter(function (entry) { return entry.region === activeRegion; });
      var visibleCards = 0;

      cards.forEach(function (card) {
        var show = normalizeRegion(card.dataset.region) === activeRegion;
        card.hidden = !show;
        if (show) visibleCards += 1;
      });
      tabs.forEach(function (tab) {
        var selected = tab.dataset.nhMarketTab === activeRegion;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });
      if (count) count.textContent = visible.length + (visible.length === 1 ? ' location' : ' locations');
      if (empty) empty.hidden = visibleCards > 0;

      if (layer) {
        layer.clearLayers();
        visible.forEach(function (entry) { if (entry.marker) layer.addLayer(entry.marker); });
        fitVisible(visible);
      }
    }


    var nearbyButton = section.querySelector('[data-nh-find-nearby]');
    var nearbyStatus = section.querySelector('[data-nh-nearby-status]');
    if (nearbyButton && nearbyStatus) {
      nearbyButton.addEventListener('click', function () {
        if (nearbyButton.disabled) return;
        nearbyStatus.replaceChildren();
        if (!navigator.geolocation) {
          nearbyStatus.textContent = nearbyButton.dataset.unavailable;
          return;
        }
        if (!entries.length) {
          nearbyStatus.textContent = nearbyButton.dataset.empty;
          return;
        }
        nearbyButton.disabled = true;
        nearbyStatus.textContent = nearbyButton.dataset.finding;
        navigator.geolocation.getCurrentPosition(function (position) {
          nearbyButton.disabled = false;
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          var toRadians = Math.PI / 180;
          var ranked = entries.filter(hasCoordinates).map(function (entry) {
            var latDelta = (entry.latitude - latitude) * toRadians;
            var lngDelta = (entry.longitude - longitude) * toRadians;
            var a = Math.sin(latDelta / 2) ** 2 + Math.cos(latitude * toRadians) * Math.cos(entry.latitude * toRadians) * Math.sin(lngDelta / 2) ** 2;
            var distance = 3958.8 * 2 * Math.atan2(Math.sqrt(Math.max(0, Math.min(1, a))), Math.sqrt(Math.max(0, 1 - a)));
            return { entry: entry, distance: distance };
          }).sort(function (left, right) { return left.distance - right.distance; });
          var nearest = ranked[0];
          if (!nearest) {
            nearbyStatus.textContent = nearbyButton.dataset.empty;
            return;
          }
          activate(nearest.entry.region);
          mobileDetails.forEach(function (details) { details.open = details.dataset.nhMarketDetails === nearest.entry.region; });
          cards.forEach(function (card) { card.classList.toggle('is-nearest', card === nearest.entry.card); });
          nearbyStatus.textContent = nearbyButton.dataset.closest.replace('[name]', nearest.entry.name).replace('[distance]', nearest.distance.toFixed(1));
          var directions = document.createElement('a');
          directions.href = directionsUrl(nearest.entry);
          directions.target = '_blank';
          directions.rel = 'noopener';
          directions.textContent = nearbyButton.dataset.directions + ' ↗';
          nearbyStatus.appendChild(directions);
          if (map && nearest.entry.marker) {
            var reveal = function () {
              map.setView([nearest.entry.latitude, nearest.entry.longitude], 15);
              nearest.entry.marker.openPopup();
            };
            if (layer && layer.zoomToShowLayer) layer.zoomToShowLayer(nearest.entry.marker, reveal);
            else reveal();
          }
        }, function () {
          nearbyButton.disabled = false;
          nearbyStatus.textContent = nearbyButton.dataset.denied;
        }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab.dataset.nhMarketTab); });
      tab.addEventListener('keydown', function (event) {
        var available = tabs.filter(function (item) { return !item.hidden; });
        var current = available.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') next = (current + 1) % available.length;
        if (event.key === 'ArrowLeft') next = (current - 1 + available.length) % available.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = available.length - 1;
        if (next === null) return;
        event.preventDefault();
        available[next].focus();
        available[next].click();
      });
    });

    mobileDetails.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        mobileDetails.forEach(function (other) { if (other !== details) other.open = false; });
        activate(details.dataset.nhMarketDetails);
      });
    });

    function popupContent(entry) {
      var popup = document.createElement('div');
      popup.className = 'nh-map-popup';
      var name = document.createElement('strong');
      name.textContent = entry.name;
      var meta = document.createElement('small');
      meta.textContent = [entry.market, entry.locationType].filter(Boolean).join(' · ');
      var address = document.createElement('span');
      address.textContent = entry.address;
      var link = document.createElement('a');
      link.href = directionsUrl(entry);
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Get directions ↗';
      popup.appendChild(name);
      if (meta.textContent) popup.appendChild(meta);
      popup.appendChild(address);
      popup.appendChild(link);
      return popup;
    }

    function makeMarker(entry, index) {
      if (!hasCoordinates(entry)) return;
      var label = entry.feed ? 'NH' : String(index + 1).padStart(2, '0');
      var icon = window.L.divIcon({
        className: 'nh-map-marker-shell',
        html: '<span class="nh-map-marker nh-map-marker--' + entry.accent + '"><b>' + label + '</b></span>',
        iconSize: [42, 48],
        iconAnchor: [21, 46],
        popupAnchor: [0, -42]
      });
      entry.marker = window.L.marker([entry.latitude, entry.longitude], { icon: icon, title: entry.name }).bindPopup(function () { return popupContent(entry); });
    }

    function startMap() {
      if (!window.L || !mapElement) throw new Error('map_unavailable');
      mapElement.innerHTML = '';
      map = window.L.map(mapElement, { scrollWheelZoom: false, preferCanvas: true }).setView([40.7, -73.6], 5);
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);
      layer = window.L.markerClusterGroup ? window.L.markerClusterGroup({ chunkedLoading: true, maxClusterRadius: 62, removeOutsideVisibleBounds: true, showCoverageOnHover: false }) : window.L.layerGroup();
      layer.addTo(map);
      entries.forEach(makeMarker);

      cards.forEach(function (card, index) {
        var button = card.querySelector('[data-nh-show-location]');
        if (!button || !entries[index] || !entries[index].marker) return;
        button.addEventListener('click', function () {
          var entry = entries[index];
          function reveal() { map.setView([entry.latitude, entry.longitude], 15); entry.marker.openPopup(); }
          if (layer.zoomToShowLayer) layer.zoomToShowLayer(entry.marker, reveal); else reveal();
          if (window.matchMedia('(max-width: 1024px)').matches) mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      updateCounts();
      activate(activeRegion);

      var feedUrl = section.dataset.feedUrl;
      var feedLimit = Math.min(10000, Math.max(1, parseInt(section.dataset.feedLimit, 10) || 10000));
      if (!feedUrl) return;
      if (feedStatus) feedStatus.textContent = 'Loading expanded directory…';
      fetch(feedUrl, { credentials: 'omit', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('feed_failed'); return response.json(); })
        .then(function (payload) {
          var additions = parseLocationFeed(payload, feedLimit);
          var startingIndex = entries.length;
          additions.forEach(function (entry, index) { makeMarker(entry, startingIndex + index); entries.push(entry); });
          updateCounts();
          activate(activeRegion);
          if (feedStatus) feedStatus.textContent = additions.length + ' expanded-directory locations loaded.';
        })
        .catch(function () { if (feedStatus) feedStatus.textContent = 'Expanded directory unavailable; published locations remain active.'; });
    }

    updateCounts();
    activate(activeRegion);
    if (!mapElement) return;
    loadLocationStyles();
    loadLocationScript('NHLeafletScript', 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js')
      .then(function () { return loadLocationScript('NHLeafletClusterScript', 'https://cdn.jsdelivr.net/npm/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js'); })
      .then(startMap)
      .catch(function () {
        mapElement.classList.add('is-unavailable');
        mapElement.innerHTML = '<p>The interactive map is temporarily unavailable. Use the location cards for addresses and directions.</p>';
      });
  }

  function initLocationSections(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-nh-locations]')) initLocationSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-nh-locations]'), initLocationSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initLocationSections(document); });
  } else {
    initLocationSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLocationSections(event.target);
  });
})();

